/* eslint-disable react/display-name */
import React from 'react'
import { Link } from 'gatsby'
import { useSelector } from 'react-redux'
import styled from '@emotion/styled'
import { getRegionPrefix } from '../../../../shared-utils/src/components/utils/region.js'

const StyledLink = styled(Link)`
  font-size: 1rem;
  font-weight: normal;
  color: ${props => props.theme.colors.navLinkColor};
  text-decoration: none;

`

const RegionalLink = props => {
  const { to, children, region, regional, ...otherProps } = props
	var pageRegionCode = region
	if (!region){
		//****Getting Region from date when it is not passed.*/
		pageRegionCode = useSelector((state) => state.app.region);
	}
  const regionPath = pageRegionCode && regional && getRegionPrefix(pageRegionCode) ? `/${getRegionPrefix(pageRegionCode)}${to}` : to
  return (
    <StyledLink {...otherProps} to={regionPath} activeClassName="active">
      {children}
    </StyledLink>
  )
}

export default RegionalLink
